export default __webpack_public_path__ + "static/media/paneldegestion.a3232f43.jpg";